<script setup>
import { RouterView } from 'vue-router';
import 'bootstrap'; 
import BolideAssistant from '@/components/BolideAssistant/BolideAssistant.vue';
import { globalState } from '@/config/globalState';

</script>
 
<template>
  <div id="app">
    <RouterView />
    <BolideAssistant 
      :is_open="globalState.isAssistantOpen" 
      :user="globalState.user" 
      :tiles="globalState.tiles"
      :active-property="globalState.activeProperty" 
      @close-assistant="globalState.toggleAssistant(false)" 
    />
  </div>
</template>
<style>
body{
  overflow: hidden;
}
</style>
 
 